import { Component, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BaseDataGridCellRenderer } from 'shared/abstract/base-data-grid-cell-renderer';

@Component({
    selector: 'app-data-grid-default-cell-renderer',
    templateUrl: './data-grid-default-cell-renderer.component.html',
    styleUrls: ['./data-grid-default-cell-renderer.component.scss'],
    imports: [TranslateModule],
})
export class DataGridDefaultCellRendererComponent extends BaseDataGridCellRenderer {
    public label!: string;
    public defaultValueIfNull: string | null = null;

    constructor() {
        super();
    }

    override onDataChange(): any {
        this.defaultValueIfNull = this.column.customCellRendererData?.defaultValueIfNull;

        if (!this.column?.dataKey) {
            this.label = '';
            return;
        }

        this.label = this.getValueByKeyPath(this.data, this.column?.dataKey);
    }
}
